import React from 'react';
import { useNavigate } from 'react-router-dom';
import Row from '../../../Common/Row';
import Col from '../../../Common/Col';
import Input from '../../../Common/HtmlTags/Input';
import Button from '../../../Common/HtmlTags/Button';
import LoadingIndicator from '../../../store/LoadingIndicator';
import { GoBack } from '../../../../containers/goBack/inedx';
import AdvancedUpload from '../../../store/AdanceFileUpload';
import { connect } from 'react-redux';
import { withRouter } from '../../../../withRouter';
import actions from '../../../../actions';

const AddTeamMemberForm = (props) => {
  const {
    teamMemberFormData,
    formErrors,
    teamMemberChange,
    addTeamMember,
    isLoading,
    isLightMode,
  } = props;

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    addTeamMember(navigate);
  };

  return (
    <div className='add-event d-flex flex-column mb-custom-5em'>
      {isLoading && <LoadingIndicator isLightMode={isLightMode} />}
      <div
        style={{
          marginBottom: '-1em',
          justifyContent: 'space-between',
          padding: '0em 1em',
        }}
        className='d-flex team-members-header'
      >
        <h2 className={`${isLightMode ? 'p-black' : 'p-white'} font-size-25`}>Add Team Member</h2>
        <GoBack navigate={navigate} />
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <Row>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12' lg='6'>
            <Input
              type='text'
              error={formErrors.name}
              label='Name'
              name='name'
              placeholder='Enter team member name'
              value={teamMemberFormData.name}
              onInputChange={teamMemberChange}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12' lg='6'>
            <Input
              type='text'
              error={formErrors.role}
              label='Role'
              name='role'
              placeholder='Enter role'
              value={teamMemberFormData.role}
              onInputChange={teamMemberChange}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12'>
            <Input
              type='textarea'
              error={formErrors.bio}
              label='Bio'
              name='bio'
              rows={5}
              placeholder='Enter a short bio'
              value={teamMemberFormData.bio}
              onInputChange={teamMemberChange}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12'>
            <h5>Upload Photo</h5>
            <AdvancedUpload
              error={formErrors.image}
              onFilesChange={(files) => teamMemberChange('image', files)}
              imageLimit={10 * 1024 * 1024}
              videoLimit={0}
              limit={1}
              vLimit={0}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '1em' }}>
          <div className='add-event-actions'>
            <Button style={{ padding: '10px 20px' }} text='Save Team Member' />
          </div>
        </Row>
      </form>
    </div>
  );
};

class AddTeamMember extends React.PureComponent {
  componentDidMount() {
    this.props.resetTeamMember();
  }

  render() {
    return <AddTeamMemberForm {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  teamMemberFormData: state.teamMembers.teamMemberFormData,
  formErrors: state.teamMembers.formErrors,
  isLightMode: state.dashboard.isLightMode,
  isLoading: state.teamMembers.isLoading,
});

export default connect(mapStateToProps, actions)(withRouter(AddTeamMember));
